import { Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '@common/services/dialog.service';
import { UserService } from '@common/services/user.service';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../models/User';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Output() toggleSidebar = new EventEmitter();
    user: User;
    dark: boolean;
    environmentName: string;
    homeUrl = '/home';

    constructor(
        private router: Router,
        private dialogService: DialogService,
        private translateService: TranslateService,
        private userService: UserService,
        private renderer: Renderer2) {
        userService.currentUserSubject.subscribe((user) => {
            this.user = user;
            this.homeUrl =  user?.organizationId ? '/home' : user?.isVtsUser() ? '/vts/dashboard' : '/task-manager';
        });
        this.environmentName = environment.name;
    }

    ngOnInit() {
        if (JSON.parse(localStorage.getItem('dark')))
            document.getElementById('dark-theme-toggle').click();
    }

    onToggleSidebar() {
        this.toggleSidebar.emit();
    }

    login() {
        return this.router.navigate(['/login']);
    }

    toggleDarkMode() {
        this.dark = !this.dark;
        if (this.dark) {
            this.renderer.removeClass(document.body, 'lightTheme');
            this.renderer.addClass(document.body, 'darkTheme');
            localStorage.setItem('dark', JSON.stringify(this.dark));
            return;
        }
        this.renderer.removeClass(document.body, 'darkTheme');
        this.renderer.addClass(document.body, 'lightTheme');
        localStorage.setItem('dark', JSON.stringify(this.dark));
    }

    async logout() {
        const res = await this.dialogService.openConfirmDialog('Sign Out',
            this.translateService.instant('Are you sure you want to sign out?') as string
            );
        if (!res) return;
        await this.userService.logout(false);
    }
}
